const CompareIcon = () => `<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none">
  <mask id="path-1-inside-1_80_12319" fill="white">
    <rect x="2" y="4" width="19" height="16" rx="1"/>
  </mask>
  <rect x="2" y="4" width="19" height="16" rx="1" stroke="currentColor" stroke-width="4" mask="url(#path-1-inside-1_80_12319)"/>
  <line x1="12" y1="4.37112e-08" x2="12" y2="24" stroke="currentColor" stroke-width="2"/>
  <rect x="12" y="5" width="7" height="14" fill="currentColor"/>
</svg>`;
export default CompareIcon;
